export default __webpack_public_path__ + "static/media/privacy.ed78bb85.svg";